// React
import { useState } from "react"

export function useSelectCoa(): {
  value: string
  onChange: (value: string) => void
} {
  // Hooks
  const [value, setValue] = useState<string>("")

  return {
    value,
    onChange: setValue
  }
}